import { useState } from "react";
import { TaxShell } from "@/components/tax/shared";
import { OverviewPanel, YearsPanel, SettingsPanel, CasesPanel } from "@/components/tax/AdminTaxPanels";
import { PreparersPanel, IntegrationsPanel } from "@/components/tax/AdminTaxPanels2";

const TABS = [
  ["overview", "Overview", OverviewPanel], ["years", "Tax years & rules", YearsPanel], ["preparers", "Preparers", PreparersPanel],
  ["cases", "Cases", CasesPanel], ["integrations", "Integrations & errors", IntegrationsPanel], ["settings", "Settings", SettingsPanel],
];

export default function AdminTax() {
  const [tab, setTab] = useState("overview");
  const Panel = TABS.find((t) => t[0] === tab)[2];
  return (
    <TaxShell testId="admin-tax-page">
      <h2 className="text-2xl font-black tracking-tight text-slate-900 mb-4">Tax Centre administration</h2>
      <div className="flex gap-1 overflow-x-auto mb-5 bg-white border border-slate-200 rounded-full p-1 w-fit max-w-full">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`admin-tax-tab-${k}`} onClick={() => setTab(k)}
            className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200 ${tab === k ? "bg-red-600 text-white" : "text-slate-600 hover:text-slate-900"}`}>{l}</button>
        ))}
      </div>
      <Panel />
    </TaxShell>
  );
}
